<template>
    <div class="events-board-parent-wrap">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <div v-if="selectedMenuItemName && !eventGroupsLoading && !menuLoading" class="tbb-header">
                <div class="d-flex align-center">
                    <span>
                        {{ selectedMenuItemName }}
                    </span>
                    <v-btn
                        v-if="mode == 1 && selectedMenuItemName && !eventGroupsLoading && !menuLoading && userEnterprise == enterprise"
                        class="tbb-header-btn"
                        v-tooltip.top="$t('Редактировать')"
                        small
                        tile
                        text
                        @click="$eventBus.$emit('on-board-edit-click')"
                    >
                        <v-icon left>
                            fas fa-pen
                        </v-icon>
                    </v-btn>
                </div>
            </div>
            
            <!--Панель поиска-->
            <SearchPanel
                v-model="search"
                :has-filter="false"
                @on-filter-click="onFilterClick"
            />
        </Toolbar>

        <div class="white-panel-items">
            <div class="wp-row">
                <div class="flex-grids flex-item-middle">
                    <div class="filter-title">{{ $t('Вид_отображения') }}:</div>
                    <div class="flex-item-expand status-panel">
                        <v-chip-group active-class="active-panel-item" v-model="mode" mandatory column>

                            <v-chip 
                                v-for="item in [{ id: '2', name: 'Доски' }, { id: '1', name: 'Периоды' }, { id: '3', name: 'Календарь' }]"
                                :key="item.id"
                                :value="item.id"
                                class="ma-1"
                                small
                                label
                            >
                                {{ $t(item.name) }}
                            </v-chip>

                        </v-chip-group>
                    </div>
                </div>
            </div>

            <template v-if="!eventGroupsLoading && !menuLoading">
                <div class="wp-row">
                    <div class="flex-grids flex-item-middle">
                        <div class="filter-title">{{ $t('Статус') }}:</div>
                        <div class="flex-item-expand status-panel">
                            <v-chip-group active-class="active-panel-item" v-model="status" mandatory column>

                                <v-chip
                                    v-for="item in filterStatuses"
                                    :key="item.id"
                                    :value="item.id"
                                    class="ma-1"
                                    small
                                    label
                                >
                                    {{ item.Value }}
                                    <span> {{ item.Count }} </span>
                                </v-chip>

                            </v-chip-group>
                        </div>
                    </div>
                </div>

                <div class="wp-row">
                    <div class="flex-grids flex-item-middle">
                        <div class="filter-title">{{ $t('Фильтр') }}:</div>
                        <div class="flex-item-expand status-panel status-panel-ef d-flex flex-wrap">

                            <v-select
                                v-model="category"
                                :items="filterCategories"
                                :item-text="item => $t(item.Value)"
                                item-value="id"
                                multiple
                                :clearable="!!category[0]"
                                hide-details
                                outlined
                                dense
                                append-icon="fas fa-chevron-down"
                                class="autocomplete-chip ac-200 ma-1"
                                :menu-props="{ bottom: true, offsetY: true }"
                                v-tooltip.left-center="$t('Категория')"
                            >
                            </v-select>

                            <v-select
                                v-if="mode == '3'"
                                v-model="filterBoardId"
                                :items="filterBoards"
                                :item-text="item => item.Value"
                                item-value="id"
                                hide-details
                                outlined
                                dense
                                append-icon="fas fa-chevron-down"
                                class="autocomplete-chip ac-200 ma-1"
                                :menu-props="{ bottom: true, offsetY: true }"
                                v-tooltip.left-center="$t('Сфера')"
                            >
                            </v-select>

                            <v-select
                                v-model="control"
                                :items="filterControls"
                                :item-text="item => $t(item.Value)"
                                item-value="id"
                                hide-details
                                outlined
                                dense
                                append-icon="fas fa-chevron-down"
                                class="autocomplete-chip ac-200 ma-1"
                                :menu-props="{ bottom: true, offsetY: true }"
                                v-tooltip.left-center="$t('Контролирующий')"
                            >
                            </v-select>

                            <v-select
                                v-if="canSelectMeetingEnterprise"
                                v-model="enterprise"
                                :items="filterEnterprises"
                                :item-text="item => $t(item.Value)"
                                item-value="id"
                                hide-details
                                outlined
                                dense
                                append-icon="fas fa-chevron-down"
                                class="autocomplete-chip ac-200 ma-1"
                                :menu-props="{ bottom: true, offsetY: true }"
                                v-tooltip.left-center="$t('Организация')"
                            >
                            </v-select>

                            <div
                                class="reset-filter-link"
                                @click="resetFilters"
                            >
                                {{ $t('Сбросить') }}
                            </div>

                        </div>
                    </div>
                </div>
            </template>
        </div>

        <template v-if="mode == 3 && !eventGroupsLoading">
            <EventsPlannerCalendar 
                :filtered-event-groups="filteredEventGroups"  
                :selectedMeetingId="selectedMeetingId"
                :onCalendarSelectWeek="onCalendarSelectWeek"
                @planner-calendar-event-click="onMeetingClick"
                @planner-calendar-event-dbl-click="onMeetingDblClick"         
                @planner-calendar-change-status-click="changeStatus($event.id, $event.key)"       
                @planner-calendar-delete-event-click="deletePlannedMeeting"
                @planner-calendar-add-event-click="onAddPlannedEvent"
                :getChipsData="getChipsData"
                :photo-map="resolvedImages"
                :getWorkplaceName="getWorkplaceName"
                />
        </template>
            
        <template v-else>
            <div class="events-board-parent-box" v-if="!menuLoading && !eventGroupsLoading">
                <div 
                    v-for="item in filteredEventGroups"
                    :key="item.key"
                    class="events-board-item"
                    :style="{'background': item.borderColor}"
                >
                    <div class="events-board-item-top-part" :style="{'background': item.borderColor}">
                        <div class="d-flex align-center mb-2">
                            <div class="ebi-title font-weight-bold">
                                {{ mode === '1' ? $t(item.name) : $i18n.locale == 'kk' ? item.name['kk-KZ'] : item.name['ru-RU'] }}
                            </div>
                            <v-popover
                                v-if="userEnterprise == enterprise"
                                :trigger="'click'"
                                class="ebi-menu ml-auto"
                                @click.native.stop
                            >
                                <i class="fas fa-ellipsis-v"></i>
                                <template slot="popover">
                                    <ul class="ribbon-button-submenu">
                                        <li
                                            @click.stop="onAddPlannedEvent(item.key)"
                                            v-close-popover
                                        >
                                            <v-icon left>
                                                far fa-plus
                                            </v-icon>
                                            <template>
                                                {{ $t('Добавить_мероприятие') }}
                                            </template>
                                        </li>
                                    </ul>
                                    <template>
                                        <span class="ribbon-button-submenu-title">{{ $t('Действия') }}</span>
                                    </template>
                                </template>
                            </v-popover>
                        </div>
                        <div class="d-flex align-center mb-2">
                            <div class="ebi-title">{{ $t('Элементов') }}: <span>{{ item.events.length }}</span></div>
                        </div>
                    </div>

                    <!--мероприятия-->
                    <div 
                        v-for="event in item.events" 
                        :class="{ 'ebi-event-box': true, 'ebi-event-box-active': selectedMeetingId == event.id }"
                        :key="event.id"
                        @click="onMeetingClick(event.id)"
                        @dblclick="onMeetingDblClick({ id: event.id, type: 'None.PlannedMeeting' })"
                    >
                        <div class="d-flex align-top">
                            <i 
                                :class="[event.status == 1 ? 'fas' : 'far', 'fa-check-circle', 'ebi-event-status']"
                                :style="{'color': event.status == 1 ? 'green' : ''}"
                                @click.stop="changeStatus(event.id, item.key)"
                            ></i>
                            <div class="ebi-event-title">{{ event.subject }}</div>
                            <v-popover 
                                :trigger="'click'"
                                class="ebi-event-action-btn ml-auto"
                                @click.native.stop
                            >
                                <i class="fas fa-ellipsis-v"></i>
                                <template slot="popover">
                                    <ul class="ribbon-button-submenu">
                                        <li
                                            @click.stop="$eventBus.$emit('open-document', { id: event.id, type: 'None.PlannedMeeting' })"
                                            v-close-popover
                                        >
                                            <v-icon left>
                                                far fa-file-spreadsheet
                                            </v-icon>
                                            <template>
                                                Открыть
                                            </template>
                                        </li>
                                        <li
                                            v-if="userEnterprise == enterprise"
                                            @click.stop="deletePlannedMeeting(event.id)"
                                            v-close-popover
                                        >
                                            <v-icon left>
                                                far fa-trash-alt
                                            </v-icon>
                                            <template>
                                                Удалить
                                            </template>
                                        </li>
                                    </ul>
                                    <template>
                                        <span class="ribbon-button-submenu-title">Действия</span>
                                    </template>
                                </template>
                            </v-popover>
                        </div>
                        <div class="ebi-footer-chips">
                            <div class="d-flex align-center" v-if="getChipsData(event.tags).length > 0">
                                <div class="onlyReadData more-per-lab-wrap">
                                    <v-tag-chip
                                        v-for="(chip, i) in getChipsData(event.tags)" :key="i"
                                        :name="$t(chip.Value)"
                                        :chipColor="chip.color"
                                        :icon="chip.icon"
                                        chipOpacity="1"
                                        textColor="#fff"
                                        iconColor="#fff"
                                    />
                                </div>
                            </div>
                            <div class="onlyReadData" v-if="event.curator_workplace_id">
                                <v-workplace-chip 
                                    :id="event.curator_workplace_id"
                                    :name="getWorkplaceName(event.curator_workplace_id)"
                                    :canDelete="false"
                                />
                            </div>
                            <div class="d-flex align-center">
                                <!-- Фактический срок -->
                                <div class="onlyReadData more-per-lab-wrap">
                                    <v-tag-chip
                                        v-if="event.date"
                                        :name="event.date"
                                        icon="fas fa-calendar-alt"
                                    />
                                </div>
                                <v-spacer></v-spacer>
                                <div class="ebi-fc-icon-text">
                                    <i class="fas fa-comments-alt"></i>
                                    {{ event.comments }}
                                </div>
                                <div class="ebi-fc-icon-text">
                                    <i class="fas fa-paperclip"></i>
                                    {{ event.attachments }}
                                </div>
                                <div 
                                    v-if="event.controller_workplace_id"
                                    class="ebi-fc-icon-text" 
                                    @click.stop="produceGlobalEvent(event.controller_workplace_id)" 
                                >
                                    <i v-if="!resolvedImages[event.controller_workplace_id]" class="fas fa-user-circle ebi-event-user-icon"></i>
                                    <v-img
                                        v-else
                                        :src="resolvedImages[event.controller_workplace_id]"
                                        :lazy-src="resolvedImages[event.controller_workplace_id]"
                                        width="21"
                                        height="21"
                                        max-width="21"
                                        max-height="21"
                                        class="rounded-circle"
                                    >
                                    </v-img>
                                </div>
                                <div v-else style="width:28px;"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>

        <!--панель детализации мероприятия-->
        <div
            class="ebdp-state-btn"
            :style="{ 'visibility': selectedMeetingId !== null ? 'visible' : 'hidden', 'right': detailPanelVisible ? '33.333%' : '0' }"
            @click.stop="detailPanelVisible = !detailPanelVisible"
        >
            <i v-if="detailPanelVisible" class="far fa-arrow-to-right"></i>
            <i v-else class="far fa-file-invoice"></i>
        </div>

        <div 
            class="events-board-detail-panel"
            :style="{'width': detailPanelVisible ? '50%' : '0'}"
        >
            <div 
                v-if="detailPanelVisible && selectedMeeting && !selectedMeetingLoading"
                :class="{'ebdp-inner-wrap': true, 'd-flex flex-column': detailPanelTab == 1 }"    
            >

                <div class="ebdp-inner-fixed-part">

                    <div class="ebdp-title-wrap d-flex align-top">
                        <i 
                            :class="[selectedMeeting.Status == 1 ? 'fas' : 'far', 'fa-check-circle', 'mr-2']"
                            :style="{'color': selectedMeeting.Status == 1 ? 'green' : ''}"
                        ></i>
                        <div 
                            class="ebdp-title"
                        >
                            {{ selectedMeeting.Subject }}
                        </div>
                    </div>

                    <!--табы-->
                    <v-tabs
                        v-model="detailPanelTab"
                        background-color="transparent"
                        slider-size="3"
                        class="tab-selector-panel"
                        mobile-breakpoint="0"
                    >
                        <v-tabs-slider color="#E43958"></v-tabs-slider>

                        <v-tab 
                            v-for="item in pages"
                            :key="item.FormType + selectedMeeting.id"
                        >
                            <template v-if="item.Count < 0">
                                {{ item.Name }}
                            </template> 
                            <template v-else>
                                {{ item.Name }}
                            </template>   
                        </v-tab>

                    </v-tabs>

                </div>

                <v-tabs-items
                    v-model="detailPanelTab"
                    :class="{'tab-content-panel': true, 'tab-content-panel-comment': detailPanelTab == 1 }"
                >
                    <v-tab-item 
                        v-for="item in pages"
                        :key="item.FormType + selectedMeeting.id"
                    >
                        <component :is="item.FormType" :meeting="selectedMeeting" />
                    </v-tab-item>
                </v-tabs-items>

            </div>
            <div v-else-if="detailPanelVisible && !selectedMeeting && !selectedMeetingLoading" class="ebdp-inner-wrap">
                <div class="ebdp-inner-fixed-part">
                    <div class="d-flex align-top">
                        <i
                            class="fas fa-exclamation-triangle mr-2"
                            :style="{'color': 'red'}"
                        ></i>
                        <div class="ebdp-title">{{ $t('Нет_данных') }}</div>
                    </div>
                </div>
            </div>
            <div v-else-if="detailPanelVisible && selectedMeetingLoading" class="ebdp-inner-wrap">
                <div class="ebdp-inner-fixed-part">
                    <div class="d-flex align-top">
                        <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';

import sys from '@/services/system';
import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import EventsPlannerCalendar from '@/components/planner/calendar/Calendar.vue';

import Chat from '@/components/planner/detail-tabs/Chat.vue';
import Form from '@/components/planner/detail-tabs/Form.vue';
import Attachments from '@/components/planner/detail-tabs/Attachments.vue';

export default {
    name: "EventsBoard",
    components: {
        Toolbar,
        SearchPanel,
        EventsPlannerCalendar,
        Chat,
        Form,
        Attachments
    },
    asyncComputed: {
        filterEnterprises : {
            async get() {
                let enterprisesResponse = await httpAPI({
                    url: `api/plannedevent/enterpriseslist`,
                    method: 'GET'
                });

                return enterprisesResponse?.data?.Payload.map(b => ({ id: b.id, Value: this.$i18n.locale == 'kk' ? b.name['kk-KZ'] : b.name['ru-RU'] })) ?? [];
            },
            default: []
        }
    },
    computed: {
        ...mapGetters('global/auth', { userEnterprise: 'getUserEnterpriseId' }),
        ...mapGetters('planner',
        { 
            menuLoading: 'isMenuLoading',
            meetingCategories: 'getMeetingCategories',
            meetingMonths: 'getMeetingMonths',
            meetingYears: 'getMeetingYears', 
            selectedYear: 'getSelectedYear',
            meetingStatuses: 'getMeetingStatuses',
            weekDays: 'getWeekDays',
            selectedMenuItemName: 'getMenuItemName',
            boards: 'getBoards'
        }),
        mode: {
            get: function() {
                return this.$store.getters['planner/getMode'];
            },
            set: function(v) {
                this.$store.commit('planner/SET_MODE', v);
            }
        },
        calendarDate(){
            return this.$store.getters['planner/getCalendarDate']
        },
        identifier() {
            return this.$store.getters['planner/getId'];
        },
        search: {
            get: function() {
                return this.$store.getters['planner/getSearch']
            },
            set: _.debounce(function(v) {
                this.$store.commit('planner/SET_SEARCH', v );
            }, 500)
        },
        category: {
            get: function() {
                return this.$store.getters['planner/getFilterCategory']
            },
            set: function(v) {
                if (!v || v.length == 0 || !v[v.length-1]) {
                    v = [null];
                }
                else if (!v[0])  {
                    v.splice(0,1);
                }

                this.$store.commit('planner/SET_FILTER_CATEGORY', v );
            }
        },
        filterCategories() {
            let categories = [...this.meetingCategories];
            categories.unshift({ id: null, Value: "Все_категории" });
            categories.push({ id: Number.MAX_SAFE_INTEGER, Value: "Без_категории" });
            return categories;
        },
        status: {
            get: function() {
                return this.$store.getters['planner/getFilterStatus']
            },
            set: function(v) {
                this.$store.commit('planner/SET_FILTER_STATUS', v );
            }
        },
        filterStatuses() {
            let statuses = [
                { id: "All", Value: this.$t("Все"), Count: this.filteredEventsCount },
                { id: "Today", Value: this.$t("Сегодня"), Count: this.filteredEventsCountToday },
                { id: "Completed", Value: this.$t("Проведено"), Count: this.filteredEventsCountCompleted },
                { id: "Expired", Value: this.$t("Просрочено"), Count: this.filteredEventsCountExpired },
                { id: "InWork", Value: this.$t("В_работе"), Count: this.filteredEventsCountInWork }
            ];

            return statuses;
        },
        filterBoardId: {
            get: function() {
                return this.$store.getters['planner/getFilterBoardId']
            },
            set: function(v) {
                this.$store.commit('planner/SET_FILTER_BOARD_ID', v );
            }
        },
        filterBoards() {
            let tmp = this.boards.map(b => ({ id: b.id, Value: this.$i18n.locale == 'kk' ? b.name['kk-KZ'] : b.name['ru-RU'] })) ?? [];
            tmp.unshift({ id: null, Value: this.$t('Все_сферы') });
            return tmp;
        },
        control : {
            get: function() {
                return this.$store.getters['planner/getFilterControlId']
            },
            set: function(v) {
                this.$store.commit('planner/SET_FILTER_CONTROL_ID', v );
            }
        },
        filterControls() {
            let controls = [...this.eventControls];
            controls.unshift({ id: 'withoutCotrol', Value: "Без_контроля" });
            controls.unshift({ id: null, Value: "Любой_контроль" });
            return controls;
        },
        enterprise: {
            get: function() {
                return this.$store.getters['planner/getFilterEnterprise'];
            },
            set: function(v) {
                this.$store.commit('planner/SET_FILTER_ENTERPRISE', v );
            }
        },
        pages() {
            let pages = 
            [
                { FormType: 'Form', Name: this.$t("Описание") },
                { FormType: 'Chat', Name: this.$t("Чат") },
            ];

            return pages;
        },
        filteredEventGroups() {
            let groups = JSON.parse(JSON.stringify(this.eventGroups));
            groups.forEach(g => {
                g.events = g.events.filter(x =>
                    (
                        this.status == "All"
                        || (this.status == "Today" && x.date != null && this.$moment(x.date, 'DD.MM.YYYY').isSame(this.$moment(), 'day'))
                        || (this.status == "Completed" && x.status === 1)
                        || (this.status == "Expired" && x.date != null && this.$moment(x.date, 'DD.MM.YYYY').isBefore(this.$moment(), 'day') && x.status !== 1)
                        || (this.status == "InWork" && (x.date == null || !this.$moment(x.date, 'DD.MM.YYYY').isBefore(this.$moment(), 'day')) && x.status !== 1)
                    )
                    &&
                    (
                        this.category == null || this.category.length == 0 || !this.category[0] //Ничего не выбрано
                        || (this.category.includes(Number.MAX_SAFE_INTEGER) && (x.tags == null || x.tags.length == 0)) // Выбрано "Без категории" и у эвента нет категории
                        || x.tags?.filter(tag => this.category.includes(tag))?.length > 0 //У эвента есть одна из выбранных категорий
                    )
                    &&
                    (
                        this.control == null
                        || (this.control === 'withoutCotrol' && !x.curator_workplace_id)
                        || x.curator_workplace_id == this.control
                    )
                    &&
                    (
                        this.mode != '3'
                        || this.filterBoardId == null
                        || x.board == this.filterBoardId
                    )
                    &&
                    (
                        this.search == null
                        || sys.checkSearch(x.subject, this.search)
                    )
                );

                g.events = this.$_(g.events)
                    .orderBy(['status', 'date'], ['desc', 'asc'])
                    .value();
            });

            return groups;
        },
        filteredEventsCount() {
            return this.eventGroups.reduce((acc, group) => acc += group?.events?.filter(x => 
                (
                    this.category == null || this.category.length == 0 || !this.category[0] //Ничего не выбрано
                    || (this.category.includes(Number.MAX_SAFE_INTEGER) && (x.tags == null || x.tags.length == 0)) // Выбрано "Без категории" и у эвента нет категории
                    || x.tags?.filter(tag => this.category.includes(tag))?.length > 0 //У эвента есть одна из выбранных категорий
                )
                &&
                (
                    this.control == null
                    || (this.control === 'withoutCotrol' && !x.curator_workplace_id)
                    || x.curator_workplace_id == this.control
                )
            )?.length ?? 0, 0);
        },
        filteredEventsCountToday() {
            return this.eventGroups.reduce((acc, group) => acc += group?.events?.filter(x => 
                (
                    x.date != null && this.$moment(x.date, 'DD.MM.YYYY').isSame(this.$moment(), 'day')
                )
                &&
                (
                    this.category == null || this.category.length == 0 || !this.category[0] //Ничего не выбрано
                    || (this.category.includes(Number.MAX_SAFE_INTEGER) && (x.tags == null || x.tags.length == 0)) // Выбрано "Без категории" и у эвента нет категории
                    || x.tags?.filter(tag => this.category.includes(tag))?.length > 0 //У эвента есть одна из выбранных категорий
                )
                &&
                (
                    this.control == null
                    || (this.control === 'withoutCotrol' && !x.curator_workplace_id)
                    || x.curator_workplace_id == this.control
                )
            )?.length ?? 0, 0);
        },
        filteredEventsCountCompleted() {
            return this.eventGroups.reduce((acc, group) => acc += group?.events?.filter(x => 
                (
                    x.status === 1
                )
                &&
                (
                    this.category == null || this.category.length == 0 || !this.category[0] //Ничего не выбрано
                    || (this.category.includes(Number.MAX_SAFE_INTEGER) && (x.tags == null || x.tags.length == 0)) // Выбрано "Без категории" и у эвента нет категории
                    || x.tags?.filter(tag => this.category.includes(tag))?.length > 0 //У эвента есть одна из выбранных категорий
                )
                &&
                (
                    this.control == null
                    || (this.control === 'withoutCotrol' && !x.curator_workplace_id)
                    || x.curator_workplace_id == this.control
                )
            )?.length ?? 0, 0);
        },
        filteredEventsCountExpired() {
            return this.eventGroups.reduce((acc, group) => acc += group?.events?.filter(x => 
                (
                    x.date != null && this.$moment(x.date, 'DD.MM.YYYY').isBefore(this.$moment(), 'day') && x.status !== 1
                )
                &&
                (
                    this.category == null || this.category.length == 0 || !this.category[0] //Ничего не выбрано
                    || (this.category.includes(Number.MAX_SAFE_INTEGER) && (x.tags == null || x.tags.length == 0)) // Выбрано "Без категории" и у эвента нет категории
                    || x.tags?.filter(tag => this.category.includes(tag))?.length > 0 //У эвента есть одна из выбранных категорий
                )
                &&
                (
                    this.control == null
                    || (this.control === 'withoutCotrol' && !x.curator_workplace_id)
                    || x.curator_workplace_id == this.control
                )
            )?.length ?? 0, 0);
        },
        filteredEventsCountInWork() {
            return this.eventGroups.reduce((acc, group) => acc += group?.events?.filter(x =>
                (
                    (x.date == null || !this.$moment(x.date, 'DD.MM.YYYY').isBefore(this.$moment(), 'day')) && x.status !== 1
                )
                &&
                (
                    this.category == null || this.category.length == 0 || !this.category[0] //Ничего не выбрано
                    || (this.category.includes(Number.MAX_SAFE_INTEGER) && (x.tags == null || x.tags.length == 0)) // Выбрано "Без категории" и у эвента нет категории
                    || x.tags?.filter(tag => this.category.includes(tag))?.length > 0 //У эвента есть одна из выбранных категорий
                )
                &&
                (
                    this.control == null
                    || (this.control === 'withoutCotrol' && !x.curator_workplace_id)
                    || x.curator_workplace_id == this.control
                )
            )?.length ?? 0, 0);
        },
        canSelectMeetingEnterprise() {
            let permissions = this.$store.getters['global/auth/getUserPermissions'];
            return permissions.includes('ViewAllPlannedMeetings');
        }
    },    
    data() {
        return {
            eventGroups: [],
            eventGroupsLoading: true,
            eventControls: [],

            detailPanelVisible: false,

            selectedMeetingId: null,
            selectedMeetingLoading: true,
            selectedMeeting: null,

            detailPanelTab: null,
            photos:[],

            isMeetingDblClicked: false,

            updatingFromWeekWatcher: false,
            imageCache: {},        // Кэш промисов (id -> Promise)
            resolvedImages: {}     // Кэш готовых Base64-картинок (id -> string)
        }
    },
    methods: {
        ...mapActions('global/actionsource', ['loadDataSource']),
        onToolbarClick() {
            console.log('onToolbarClick');
        },
        onFilterClick() {
            console.log('onFilterClick');
        },
        getChipsData(keys) {
            if (!keys)
                return [];

            return this.meetingCategories.filter(c => keys.includes(c.id));
        },
        async fetchImage(id) {
            // Если уже загружено — вернуть сразу
            if (this.resolvedImages[id]) {
                return this.resolvedImages[id];
            }

            // Если уже загружается — вернуть промис
            if (this.imageCache[id]) {
                return this.imageCache[id];
            }

            // Иначе начать загрузку и сохранить промис в кэш
            this.imageCache[id] = await httpAPI({
                url: `/api/ems/getworkplacephoto?id=${id}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })
            .then(response => {
                const imageUrl = response.data?.Payload?.Data?.Object ?? '';
                this.$set(this.resolvedImages, id, imageUrl);
                return imageUrl;
            })
            .catch(error => {
                console.error(`Ошибка загрузки фото для ID ${id}:`, error);
                return null;
            });

            return this.imageCache[id];
        },
        deletePlannedMeeting(plannedMeetingId) {
            if (this.userEnterprise != this.enterprise)
                return;

            this.$notify.confirm(
                this.$t('Мероприятие_будет_удалено._Продолжить?'),
                async () => {
                    this.$store.dispatch('setOverlayVisible', { visible: true, text: `Мероприятие_удаляется...` }, { root: true });

                    let deleteResponse = await httpAPI({
                        url: `api/actions/delete?type=None.PlannedMeeting&id=${plannedMeetingId}`,
                        method: 'DELETE',
                        headers: { 'Content-Type': 'application/json' }
                    });

                    if (deleteResponse) {
                        await this.updatePlannerBoard();
                        this.$eventBus.$emit('update-boardcounter');
                        this.$notify.success(deleteResponse.data.Payload.Message);
                    }

                    this.$store.dispatch('setOverlayVisible', { visible: false }, { root: true });
                }
            );
        },
        async updatePlannerBoard() {
            if (this.mode!=3 && !this.identifier)
                return;
            this.eventGroupsLoading = true;
            let filter = null;
            switch(this.mode)
            {
                case "1":
                    filter = { Board: this.identifier, Year: this.selectedYear };
                    break;

                case "3": {
                    const momentDate = this.$moment(this.calendarDate);
                    filter = { Week: momentDate.isoWeek(), Year: momentDate.year() };
                    break;
                }

                default:
                    filter = { Month: this.identifier, Year: this.selectedYear };
                    break;
            }
            
            if (this.canSelectMeetingEnterprise){
                filter.Enterprise = this.enterprise;
            }

            let response = await httpAPI({
                url: `api/plannedevent/list?filter=${JSON.stringify(filter)}`,
                method: 'GET'
            });
            
            this.photos = response.data.Payload.photos;
            let groups = [];
            const allExecuters = response.data.Payload.events
                .filter(item => item.controller_workplace_id)
                .map(item => item.controller_workplace_id)
                .filter(this.onlyUnique);
            allExecuters.forEach(async (id) => { await this.fetchImage(id)});
            let allControlsIds = response.data.Payload.events
                .filter(item => item.curator_workplace_id)
                .map(item => item.curator_workplace_id)
                .filter(this.onlyUnique);
            this.control = null;
            this.eventControls = this.photos
                .filter(p => allControlsIds.includes(p.id))
                .sort((a,b) => {
                    if (a.idx && !b.idx)
                        return -1;
                    if (!a.idx && b.idx)
                        return 1;
                    if (!a.idx && !b.idx) {
                        if (a.fio < b.fio)
                            return -1;
                        if (a.fio > b.fio)
                            return 1;
                        return 0;    
                    }
                    return a.idx - b.idx;
                 })
                .map(p => ({id:p.id, Value:sys.sanitizeName(p.fio)}));
            //[...new Map(allControls.map(item =>[item["id"], item])).values()];
            

            switch (this.mode)
            {
                case "1":
                {
                    this.meetingMonths.forEach(month => {
                        groups.push({
                            key: month.id, 
                            name: month.Value,
                            borderColor: month.color,
                            events: response.data.Payload.events.filter(event => event.mon == month.id) ?? []
                        });
                    });
                    break;
                }
                case "2":
                {
                    let colors = this.meetingMonths.map(month => month.color);

                    this.boards.forEach((board, index) => {
                        groups.push({
                            key: board.id,
                            name: board.name,
                            borderColor: colors[index % 12],
                            events: response.data.Payload.events.filter(event => event.board == board.id) ?? []
                        });
                    });
                    break;
                }
                case "3":
                {  
                    let startOfWeek = this.$moment(this.calendarDate).startOf('isoWeek');
                    let dates = [];

                    for (let i = 0; i < 7; i++) {
                        dates.push(startOfWeek.clone().add(i, 'days'));
                    }

                    this.weekDays.forEach(d => {
                        groups.push({
                            key: d.id, 
                            name: d.ShortVal,
                            date: dates[d.id - 1].format('YYYY-MM-DD'),
                            borderColor: d.color,
                            events: response.data.Payload.events.filter(event => event.date == dates[d.id - 1].format('DD.MM.YYYY')) ?? []
                        });
                    });

                    break;    
                }
                default:
                    break
            }

            this.eventGroups = groups;
            this.eventGroupsLoading = false;
        }, 
        onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
        },
        getWorkplaceName(id){
            return this.eventControls.find(item => item.id==id)?.Value;
        },
        /*watchForWeek() {
            this.unwatchWeekFunc = this.$watch('week', function(val) {

                if (this.mode  == '3') {
                    let monthStartOfWeek = `${this.$moment().year(this.$moment().year()).isoWeek(val).startOf('isoWeek').month() + 1}w`;

                    if (this.identifier != monthStartOfWeek) {
                        this.updatingFromWeekWatcher = true;
                        this.$eventBus.$emit('update-identifier', monthStartOfWeek);
                    }

                    this.updatePlannerBoard(val);
                }
            });
        }, 
        unwatchForWeek() {
            if (this.unwatchWeekFunc)
                this.unwatchWeekFunc();
        },*/
        produceGlobalEvent(id){
            if (id)
                this.$eventBus.$emit('show-workplace-information', id);
        },
        async onAddPlannedEvent(id) {
            if (this.userEnterprise != this.enterprise)
                return;

            let data = null;
            switch(this.mode)
            {
                case "1": data = {board: this.identifier, month: Number(id), year: Number(this.selectedYear)}; break;
                case "2": data = {board: id, month: Number(this.identifier), year: Number(this.selectedYear)}; break;
                case "3": {
                    const momentDate = this.$moment(this.calendarDate);
                    data = {board: null, month: momentDate.month() + 1, year: momentDate.year()}; 
                    break;
                }
                default: break;
            }
            this.$store.commit('planner/SET_CREATION_BAG', data);
            await this.loadDataSource({ createType: 'None.PlannedMeeting', navigate: true, common: false });
        },       
        onMeetingDblClick(v) {
            this.debouncedMeetingClick.cancel();
            this.$eventBus.$emit('open-document', v);
        },
        onMeetingClick(id) {
            this.debouncedMeetingClick(id);
        },
        async loadMeetingDetails(id) {
            this.selectedMeetingLoading = true;
            
            let meetingResponse = await httpAPI({
                url: `api/actions/open?type=None.PlannedMeeting&id=${id}`,
                method: 'GET',
                headers: { 'isCommon': false },
            });

            this.selectedMeeting = meetingResponse?.data?.Payload?.Data?.Object;
            this.selectedMeetingLoading = false;
        },
        eventName(name) {
            if (name?.length > 200)
                return `${name.substring(0, 199)}...`;
            else
                return name;
        },
        withTooltip(name) {
            return name?.length > 200;
        },
        tooltipText(name) {
            let tooltip = "";

            if (this.withTooltip(name))
                tooltip += name;

            return tooltip.length ? tooltip : null;
        },
        async changeStatus(id, groupKey){
            let response = await httpAPI({
                url: `api/plannedevent/changestatusplannedmeeting?id=${id}`,
                method: 'GET'
            });

            if (response) {
                let meeting = this.eventGroups.find(g => g.key == groupKey)?.events.find(e => e.id == id);

                if (meeting)
                    meeting.status = meeting.status == 1 ? 2 : 1;
            }
        },
        onCalendarSelectWeek(){
            this.updatePlannerBoard();
        },
        /*onCalendarWeekClick(val) {
            if (this.selectedYear == 2026 && val < 0 && this.week == 1){
                this.meetingYears[2026] = false;
                this.meetingYears[2025] = true;
                this.week = 52;
            }
            else if (this.selectedYear == 2025 && val > 0 && this.week == 52){
                this.meetingYears[2026] = true;
                this.meetingYears[2025] = false;
                this.week = 1;
            }
            else if ((val < 0 && this.week != 1 ) || (val > 0 && this.week != 52)){
                this.week += val;
            }
        },*/
        resetFilters() {
            //this.status = "All";
            this.category = null;
            this.filterBoardId = null;
            this.control = null;
            this.enterprise = null;
        }
    },
    async created() {
        //данное определение метода позволяет применять метод .cancel()
        this.debouncedMeetingClick = 
            _.debounce(async function (id) {
                if (this.selectedMeetingId == id) {
                    this.detailPanelVisible = false;
                    this.selectedMeeting = null;
                    this.selectedMeetingId = null;
                    return;
                }

                this.selectedMeetingId = id;
                await this.loadMeetingDetails(id);
                this.detailPanelTab = 0;
                this.detailPanelVisible = true;
            
            }, 300);

        //this.watchForWeek();
        await this.updatePlannerBoard();
    },
    mounted() {
        this.$eventBus.$on('update-board', async () => {
            await this.updatePlannerBoard();
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('update-board');
    },
    watch: {
        enterprise: {
            handler: function() {
                this.detailPanelVisible = false;
                this.selectedMeeting = null;
                this.selectedMeetingId = null;

                this.filterBoardId = null;

                this.$store.commit('planner/SET_IDENTIFIERS', null );
                this.$eventBus.$emit('update-menu');
            }
        },
        selectedYear:{
            handler: function() {
                switch(this.mode)
                {
                    case '3':
                    {
                        if (this.updatingFromWeekWatcher) {
                            this.updatingFromWeekWatcher = false;
                        }
                        else {
                            this.updatePlannerBoard(this.week);
                        }

                        break;
                    }
                    default:
                        this.updatePlannerBoard(this.week);
                        break;
                }
            }
        },
        identifier: {
            handler: function() {
                switch(this.mode)
                {
                    case '3':
                    {
                        if (this.updatingFromWeekWatcher) {
                            this.updatingFromWeekWatcher = false;
                        }
                        else {
                            this.updatePlannerBoard();
                        }

                        break;
                    }
                    default:
                        this.updatePlannerBoard();
                        break;
                }
            }
        },

    }
}
</script>